import { DataColumn } from "../config/dataInterface";

// 一覧取得用のパラメータ作成
export function makeParams(
  dataColumn: DataColumn[],
  props: { [key: string]: number | string },
) {
  let params = dataColumn.reduce((column, difine) => {
    if (difine.serch === true) {
      if (difine.serchType === "date") {
        return {
          ...column,
          [difine.key + "_start"]: props[difine.key + "_start"],
          [difine.key + "_end"]: props[difine.key + "_end"],
        };
      } else if (difine.serchType === "payment_year_month") {
        return {
          ...column,
          payment_year: props.payment_year,
          payment_month: props.payment_month,
        };
      } else if (difine.serchType === "analysys_year_month") {
        return {
          ...column,
          analysys_granularity_month_start_year:
            props.analysys_granularity_month_start_year,
          analysys_granularity_month_start_month:
            props.analysys_granularity_month_start_month,
          analysys_granularity_month_end_year:
            props.analysys_granularity_month_end_year,
          analysys_granularity_month_end_month:
            props.analysys_granularity_month_end_month,
          analysys_granularity_date_year: props.analysys_granularity_date_year,
          analysys_granularity_date_month:
            props.analysys_granularity_date_month,
        };
      } else if (difine.serchType === "runking_day") {
        return {
          ...column,
          runking_granularity_month_year: props.runking_granularity_month_year,
          runking_granularity_month_month:
            props.runking_granularity_month_month,
          runking_granularity_date: props.runking_granularity_date,
        };
      } else {
        return {
          ...column,
          [difine.key]: props[difine.key],
        };
      }
    } else {
      return {
        ...column,
      };
    }
  }, {});
  params = {
    ...params,
    displayNumber: props.displayNumber,
    pageNumber: props.pageNumber,
  };
  return params;
}
